var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-base', {
    attrs: {
      "progress": _vm.progress,
      "showFooter": _vm.showFooter,
      "isEndUser": true,
      "showLoginButton": _vm.showLoginButton
    }
  }, [_vm._t("content")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }